import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom"; 
import { useSelector, useDispatch } from 'react-redux';
import {
  AppBar, Toolbar, Typography, Drawer, Box, Select, MenuItem, Stack,
  FormControl, TextField, InputLabel, Button, IconButton,
  Grid,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import PersonIcon from '@mui/icons-material/Person';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

import useCartofactWells from '../../../hooks/useCartofactWells';

const drawerWidth = 240;

const containerStyle = {
  width: '100vw',
  height: '100vh',
  position: 'relative'
};

const mapContainerStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 1
};

const TreatmentPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const {
    filter,
    cartofactWells,
    selectedTreatmentWells,
    ...fzpState
  } = useSelector(state => state.fpzReducer);
  // order by distance from selected well if selectedTreamentWells.length > 0
  //const orderBy = selectedTreatmentWells?.length > 0 ? {
    //orderBy: 
  //} : null;
  useCartofactWells({ toggleCartofactWells: true, boundingBox: fzpState?.map?.boundingBox, filter });

  const [mapCenter, setMapCenter] = useState(null);
  const [mapZoom, setMapZoom] = useState(null);
  

  const defaultFpzRadius = 500;
  const defaultFpzRadiusColor = '#66FFFF';
  
  const handleChangeFpzRadius = (index, fpzRadius, well) => {
    console.log('handleChangeFpzRadius', index, fpzRadius, well);
    dispatch({ type: 'UPDATE_FPZ_RADIUS', payload: { index, fpzRadius, well } });
    dispatch({ type: 'SET_OFFSET_WELLS', payload: { well, offsetWells: [] } }); // clear offsets on fpz radius change
  };

  const handleAddFpzRadius = (well) => {
    dispatch({ type: 'ADD_FPZ_RADIUS', payload: well });
    dispatch({ type: 'SET_OFFSET_WELLS', payload: { well, offsetWells: [] } }); // clear offsets on fpz radius change
  }

  const handleDeleteFpzRadius = (index, well) => {
    dispatch({ type: 'DELETE_FPZ_RADIUS', payload: { index, well } });
    dispatch({ type: 'SET_OFFSET_WELLS', payload: { well, offsetWells: [] } }); // clear offsets on fpz radius change
  }

  const handleClickWell = (well) => {
    console.log('handleClickWell', well);
    setMapCenter({ lat: well.lat, lng: well.lng });
    setMapZoom(15);
  }

  const handleDeleteWell = (well) => {
    dispatch({ type: 'DELETE_TREATMENT_WELL', payload: well });
  }

  return (
    <Box>
      {
        selectedTreatmentWells?.map((well, index) => (
          <Box
            key={index}
            sx={{
              padding: '10px 0px',
              borderBottom: '1px solid #000',
            }}
            onClick={() => handleClickWell(well)}
          >
            <Box 
              sx={{ cursor: 'pointer', textDecoration: 'none' }}
            >
              <Stack direction="row" spacing={0.5} alignItems="center">
                {well.unique_identifier}
                <IconButton
                  size="small"
                  sx={{ margin: '0px', padding: '0px'}}
                  onClick={() => {
                    handleDeleteWell(well);
                  }}
                  title="Remove Treatment Well"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Stack>
              <Typography variant="body2">{well.operator}</Typography>
            </Box>
            <Typography variant="subtitle2">
              FPZ Zone Radius
              {
                well?.fpzRadiuses?.map((fpz, i) => (
                  <Grid container alignItems="center" spacing={0.5}>
                    <Grid item xs={7}>
                      <FormControl fullWidth size="small">
                        <Select
                          labelId="select-fpz-radius-label"
                          id="select-fpz-radius"
                          value={fpz?.radius || defaultFpzRadius}
                          label="Radius"
                          onChange={(e) => {
                            handleChangeFpzRadius(i, { ...fpz, radius: e.target.value }, well)
                          }}
                        >
                          <MenuItem value={200}>200 meters</MenuItem>
                          <MenuItem value={300}>300 meters</MenuItem>
                          <MenuItem value={400}>400 meters</MenuItem>
                          <MenuItem value={500}>500 meters</MenuItem>
                          <MenuItem value={750}>750 meters</MenuItem>
                          <MenuItem value={1000}>1000 meters</MenuItem>
                          <MenuItem value={1125}>1125 meters</MenuItem>
                          <MenuItem value={1250}>1250 meters</MenuItem>
                          <MenuItem value={1500}>1500 meters</MenuItem>
                          <MenuItem value={1750}>1750 meters</MenuItem>
                          <MenuItem value={2000}>2000 meters</MenuItem>
                          <MenuItem value={2500}>2500 meters</MenuItem>
                          <MenuItem value={3000}>3000 meters</MenuItem>
                          <MenuItem value={3500}>3500 meters</MenuItem>
                          <MenuItem value={4000}>4000 meters</MenuItem>
                          <MenuItem value={4500}>4500 meters</MenuItem>
                          <MenuItem value={5000}>5000 meters</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                      <TextField
                        type="color"
                        value={ fpz?.color || defaultFpzRadiusColor}
                        onChange={(e) => handleChangeFpzRadius(i, { ...fpz, color: e.target.value }, well)}
                        fullWidth
                        variant="outlined"
                        size="small"
                        InputProps={{
                          style: {
                            padding: 0,
                            minHeight: 40,
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={1}>
                      { (i+1) === well.fpzRadiuses.length && (
                        <IconButton
                          size="small"
                          sx={{ margin: '0px', padding: '0px' }}
                          fullWidth
                          onClick={() => {
                            console.log(); 
                            handleAddFpzRadius(well);
                          }}
                          title="Add Another FPZ Radius"
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Grid>

                    <Grid item xs={1}>
                      { i > 0 && ( // cannot delete the first radius
                        <IconButton
                          size="small"
                          sx={{ margin: '0px', padding: '0px'}}
                          onClick={() => {
                            console.log(); 
                            handleDeleteFpzRadius(index, well);
                          }}
                          title="Remove FPZ Radius"
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Grid>
                  </Grid>
                ))
              }
            </Typography>
          </Box>
        ))
      }

    </Box>
  );
};

export default TreatmentPage;
